import type { ComponentSchema } from "../../../../../schema-types"
import { primaryButtonFields } from "../shared/button-schema-fields"

export const schema: ComponentSchema = {
  type: 'cart',
  label: 'Cart Section',
  description: 'The shopping cart page section.',
  supportedPages: ['cart'],
  variants: [{ id: 'v1', label: 'V1 (Neon Cinematic)' }],
  commonFields: [
    { key: 'pageTitle', label: 'Page Title', type: 'string', default: 'Shopping Cart' },
    { key: 'loadingText', label: 'Loading Text', type: 'string', default: 'Loading cart items...' },
    { key: 'emptyTitle', label: 'Empty State Title', type: 'string', default: 'Your cart is empty' },
    { key: 'emptyMessage', label: 'Empty State Message', type: 'string', default: 'Browse our products and add items to your cart.' },
    { key: 'continueShoppingText', label: 'Continue Shopping Button Text', type: 'string', default: 'Continue Shopping' },
    { key: 'continueShoppingLink', label: 'Continue Shopping Link', type: 'string', default: '/shop' },
    { key: 'summaryTitle', label: 'Order Summary Title', type: 'string', default: 'Order Summary' },
    { key: 'subtotalLabel', label: 'Subtotal Label', type: 'string', default: 'Subtotal' },
    { key: 'shippingLabel', label: 'Shipping Label', type: 'string', default: 'Shipping' },
    { key: 'shippingCalculatedText', label: 'Shipping Calculated Text', type: 'string', default: 'Calculated at checkout' },
    { key: 'taxLabel', label: 'Tax Label', type: 'string', default: 'Tax' },
    { key: 'totalLabel', label: 'Total Label', type: 'string', default: 'Total' },
    { key: 'checkoutButtonText', label: 'Checkout Button Text', type: 'string', default: 'Proceed to Checkout' },
    { key: 'checkoutLink', label: 'Checkout Link', type: 'string', default: '/checkout' },
    { key: 'secureCheckoutText', label: 'Secure Checkout Label', type: 'string', default: 'SSL Secure Checkout' },

    // ─── Buttons ──────────────────────────────────────────────────────
    ...primaryButtonFields('buttons.checkout', 'Proceed to Checkout Button'),
  ],
}
